import Arotate from '../Arotate';
import './index.css';

export default {
  name: 'Arotation',
  render() {
    const { ...attrs } = this.$attrs;
    return (<Arotate {...{ attrs }} />);
  },
}